import React from 'react'
import { Drawer } from 'antd'
import { useTranslation } from 'react-i18next'
import Icons from '@commonComponents/Icons'

const USER_ICON = 'User'
const COMMENT_ICON = 'Comment'

const JobComment = (props) => {
  const { t } = useTranslation()
  const { job } = props

  return (
    <Drawer
      title={t('jobs.job.info.orderComment')}
      width={500}
      onClose={props.handleJobComment}
      visible={props.visible}
    >
      <div>
        <dl style={{ display: 'flex' }}>
          <dt style={{ marginRight: '.5em' }}>
            <Icons iconName={USER_ICON} /> {t('jobs.job.info.client')}:
          </dt>
          <dd class='secondary-text'>{`${job.receiver.firstName} ${job.receiver.lastName}`}</dd>
        </dl>
        <dl>
          <dt>
            <Icons iconName={COMMENT_ICON} /> {t('jobs.job.info.comment')}:
          </dt>
          <dd class='secondary-text'>{`"${job.jobComment}"`}</dd>
        </dl>
      </div>
    </Drawer>
  )
}

export default JobComment
